var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30588_16853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9748 29.411C26.881 29.411 31.669 24.6495 31.669 18.7758C31.669 12.9022 26.881 8.14062 20.9748 8.14062C15.0686 8.14062 10.2805 12.9022 10.2805 18.7758C10.2805 24.6495 15.0686 29.411 20.9748 29.411Z",
    fill: "#2B71F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8766 42.547C38.4212 39.8918 35.3782 37.7378 33.0149 36.2958C29.4709 34.2867 25.2888 33.1923 20.9749 33.1923C15.1911 33.1923 9.64431 35.1595 5.55458 38.6608C3.14056 40.7276 1.35093 43.2291 0.289672 45.9503C-0.92444 49.0634 1.86402 51.863 5.19062 51.863H36.7592C37.044 51.863 37.3248 51.8425 37.5996 51.803H45.1511C45.2054 48.4405 43.4261 45.304 40.8766 42.547Z",
    fill: "#2B71F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1114 32.1544C46.8851 32.1544 50.755 28.2845 50.755 23.5108C50.755 18.7371 46.8851 14.8672 42.1114 14.8672C37.3377 14.8672 33.4678 18.7371 33.4678 23.5108C33.4678 28.2845 37.3377 32.1544 42.1114 32.1544Z",
    fill: "#4FB5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0822 35.7693C37.855 35.3157 39.707 35.0803 41.5842 35.0803C46.6388 35.0803 51.5296 36.7883 55.1719 39.8905C56.9064 41.368 58.4237 42.8808 59.4561 45.0298C59.9213 45.9984 60.1212 47.0086 59.9253 47.9964C59.727 48.9965 59.1615 49.7776 58.4562 50.3414C57.1179 51.4108 55.1745 51.8003 53.3746 51.8003H47.0589C47.1165 47.6051 44.8775 43.8875 42.1527 40.9409C40.2667 38.9015 38.0823 37.1543 36.0822 35.7693Z",
    fill: "#4FB5F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30588_16853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMessages);
export default __webpack_public_path__ + "static/media/my-messages.e96d03c57ef43fadda298bba2fe40885.svg";
export { ForwardRef as ReactComponent };